var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n  ─── 四川九旅&智慧旅业 ───"),_c('div',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备19023567号-4")])])])}]

export { render, staticRenderFns }